import { render, staticRenderFns } from "./Approvals.vue?vue&type=template&id=426edf5e&scoped=true"
import script from "./Approvals.vue?vue&type=script&lang=js"
export * from "./Approvals.vue?vue&type=script&lang=js"
import style0 from "./Approvals.vue?vue&type=style&index=0&id=426edf5e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426edf5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('426edf5e')) {
      api.createRecord('426edf5e', component.options)
    } else {
      api.reload('426edf5e', component.options)
    }
    module.hot.accept("./Approvals.vue?vue&type=template&id=426edf5e&scoped=true", function () {
      api.rerender('426edf5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/influencer/Approvals.vue"
export default component.exports